import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import HttpService from '../services/httpService';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha'; // Import the reCAPTCHA component
import '../App.css'
import decorpotLogo from "../assets/img/org/decorpot_new_logo.png";
import { SpecificUserCategory } from '../utils/index';

const VendorIvrsForm = (props) => {
    const history = useHistory(); // Initialize useHistory for navigation
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        companyName: '',
        productService: ''
    });
    const [storeSpecificUserDetails, setSpecificUserDetails] = useState([]);
    const [toggleForm, setToggleForm] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null); // State to hold the CAPTCHA response

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Function to validate form inputs
    const validateForm = () => {
        const { name, email, mobile } = formData;
        
        // Name Validation: Ensure name is not empty
        if (!name || name.trim().length < 3) {
            props.setSnackInfo('Name must be at least 3 non-space characters', 'error');
            return false;
        }

        // Email Validation: Ensure email is in proper format
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email || !emailRegex.test(email)) {
            props.setSnackInfo('Please enter a valid email address', 'error');
            return false;
        }

        // Phone Number Validation: Ensure phone number is exactly 10 digits
        const phoneRegex = /^[0-9]{10}$/;
        if (!mobile || !phoneRegex.test(mobile)) {
            props.setSnackInfo('Phone number should be exactly 10 digits', 'error');
            return false;
        }

        // CAPTCHA Validation: Ensure CAPTCHA is completed
        if (!captchaValue) {
            props.setSnackInfo('Please complete the CAPTCHA', 'error');
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Perform form validation
        if (!validateForm()) {
            return; // Stop submission if validation fails
        }

        const { departmentId, teamId, _id, name, email } = storeSpecificUserDetails[0] || {};

        const dataToSend = {
            assignedDepartment: departmentId,
            assignedTeam: teamId,
            email: email,
            category: SpecificUserCategory.vendorCategory,
            assignedTo: { _id, name, email },
            status: 'Pending',
            otherProjectDetails: {
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile,
                companyName: formData.companyName,
                productService: formData.productService
            }
        };

        try {
            // Show loading indicator
            props.setLoading(true);

            const response = await HttpService.submitVendorForm(dataToSend);
            setToggleForm(true);
            localStorage.setItem('formFilled', JSON.stringify(true)); // Set form status in localStorage
            props.setSnackInfo('Form Submitted Successfully', 'success');
        } catch (error) {
            props.setSnackInfo('Something Went Wrong', 'error');
        } finally {
            // Hide loading indicator
            props.setLoading(false);
        }
    };

    const getUserDetails = async () => {
        try {
            let res = await HttpService.getUserForWhatsAppMessage();
            setSpecificUserDetails(res.data['Vendor Management']);
        } catch (error) {
            props.setSnackInfo('Failed to fetch user details', 'error');
        }
    };

    useEffect(() => {
        getUserDetails();
    }, []);
    
    useEffect(() => {
        const isFormFilled = JSON.parse(localStorage.getItem('formFilled')); // Get formFilled from localStorage
        if (isFormFilled) {
            history.push('/thank-you'); // Redirect to Thank You page if form is already filled
        }
    }, [toggleForm]);

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value); // Set the CAPTCHA response value
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f5f5f5"
        >
            <Box
                component="form"
                onSubmit={handleSubmit}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: 600,
                    width: '80%',
                    padding: '16px',
                    gap: '16px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    backgroundColor: 'white'
                }}
            >
            <div style={{ textAlign: "center" }}>
            <img
              src={decorpotLogo}
              alt="decorpot logo"
              style={{ width: "50%", textAlign: "center" }}
            />
          </div>
                <Typography variant="h6" align="center">
                    Vendor Information Form
                </Typography>

                <TextField
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    type="email"
                    fullWidth
                    required
                />
                <TextField
                    label="Phone No"
                    name="mobile"
                    value={formData.mobile}
                    type="number"
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Company Name"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Products/Services Offered"
                    name="productService"
                    value={formData.productService}
                    onChange={handleChange}
                    fullWidth
                    required
                    multiline
                    rows={3}
                />

                {/* Add reCAPTCHA Component */}
                <div className="recaptcha-container">
                    <ReCAPTCHA
                        sitekey="6Le9u30qAAAAAPctnNdH11nMpOBjbl5uJPCeLJAj"
                        onChange={handleCaptchaChange}
                    />
                </div>

                <Button type="submit" variant="contained" color="primary" fullWidth>
                    Submit
                </Button>
            </Box>
        </Box>
    );
};

export default connect(null, { setLoading, setSnackInfo })(VendorIvrsForm);